
import { defineComponent, computed } from 'vue'
import { useStore } from 'vuex'
import { DownOutlined } from '@ant-design/icons-vue'
import { logout } from '../request'
import { useRouter, useRoute } from 'vue-router'

export default defineComponent({
    components: {
        DownOutlined,
    },
    setup() {
        const store = useStore()
        const userInfo = computed(() => store.state.userInfo)
        const router = useRouter()

        async function onMenuChange({ key }) {
            await logout()
            window.location.href = '/login'
        }
        return {
            userInfo,
            onMenuChange,
        }
    },
})
